import React, { useState, useRef, useLayoutEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Carousel from './Carousel'
import { NewsData } from '../../constants/news'
import { Button } from '../ui/button'
import { ChevronRight } from '../../assets/icons'
import theme from '../../styled/theme'
import { Section, SectionTitle } from '../../styled/sections'
import { Text1Bold } from '../ui/text'
import ContactModal from '../ui/contactModal'
import {
  Card,
  CardBanner,
  CardContent,
  CardSubtitle,
  TextBlock,
} from './styled'

const NewsCard = ({ item, onReadMore }) => {
  const titleRef = useRef(null)
  const [subtitleLines, setSubtitleLines] = useState(2)

  useLayoutEffect(() => {
    const measureTitleLines = () => {
      const node = titleRef.current
      if (!node) return
      const lineHeight = parseFloat(window.getComputedStyle(node).lineHeight) || 1
      const titleLines = Math.round(node.scrollHeight / lineHeight)
      setSubtitleLines(titleLines > 1 ? 1 : 2)
    }

    measureTitleLines()
    window.addEventListener('resize', measureTitleLines)
    return () => window.removeEventListener('resize', measureTitleLines)
  }, [item.title])

  return (
    <Card
      data-carousel-card="true"
      $clickable={!!item.link}
      onClick={item.link ? () => onReadMore(item) : undefined}
    >
      <CardBanner $backgroundImage={item.image} />
      <CardContent>
        <TextBlock>
          <Text1Bold innerRef={titleRef} size="16px">
            {item.title}
          </Text1Bold>
          <CardSubtitle
            $lineClamp={subtitleLines}
            color={theme.colors.text.secondaryText}
          >
            {item.subtitle}
          </CardSubtitle>
        </TextBlock>
        <Button
          label="Leer más"
          $variant="tertiary"
          $underline={false}
          $showBorder={false}
          $mt="0px"
          iconRight={
            <ChevronRight size={10} color={theme.colors.brand.blueOmint} />
          }
          onClick={e => {
            e.stopPropagation()
            onReadMore(item)
          }}
        />
      </CardContent>
    </Card>
  )
}

const NewsSection = () => {
  const [activeModal, setActiveModal] = useState(null)
  const history = useHistory()

  const handleReadMore = item => {
    if (item.link) {
      history.push(item.link)
      return
    }
    if (item.redirect) {
      window.open(item.redirect, '_blank')
      return
    }
    setActiveModal({
      title: item.title,
      description: item.subtitle,
      bullets: item.bullets,
      note: item.note,
      contacts: item.contacts,
    })
  }

  return (
    <Section gap="16px">
      <SectionTitle mbDesktop="0px" mb="0px">
        Novedades
      </SectionTitle>
      <Carousel>
        {NewsData.map(item => (
          <NewsCard key={item.title} item={item} onReadMore={handleReadMore} />
        ))}
      </Carousel>
      {activeModal && (
        <ContactModal
          title={activeModal.title}
          description={activeModal.description}
          bullets={activeModal.bullets}
          note={activeModal.note}
          contacts={activeModal.contacts}
          onClose={() => setActiveModal(null)}
        />
      )}
    </Section>
  )
}

export default NewsSection
